/**
 * WordPress menus and ACF fields return absolute URLs. Gatsby's Link must
 * receive relative paths for client-side routing; full URLs are treated as
 * external and/or interact badly with wrappers like motion(Link).
 */
export function normalizeWpUrlForGatsby(
  to: string,
  options: { siteUrl: string; siteWpUrl: string }
): string {
  if (!to) return '/'
  const trimmed = to.trim()

  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return trimmed
  }

  if (trimmed.startsWith('//')) {
    try {
      const parsed = new URL(`https:${trimmed}`)
      return normalizeWpUrlForGatsby(parsed.href, options)
    } catch {
      return trimmed
    }
  }

  let parsed: URL
  try {
    parsed = new URL(trimmed)
  } catch {
    return trimmed
  }

  if (parsed.protocol === 'mailto:' || parsed.protocol === 'tel:') {
    return trimmed
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return trimmed
  }

  let siteOrigin: string
  let wpOrigin: string
  let siteHostname: string
  let wpHostname: string
  try {
    const siteParsed = new URL(options.siteUrl)
    const wpParsed = new URL(options.siteWpUrl)
    siteOrigin = siteParsed.origin
    wpOrigin = wpParsed.origin
    siteHostname = siteParsed.hostname
    wpHostname = wpParsed.hostname
  } catch {
    return trimmed
  }

  const allowedOrigins = new Set([siteOrigin, wpOrigin])
  const sameHost =
    parsed.hostname === siteHostname || parsed.hostname === wpHostname

  if (!allowedOrigins.has(parsed.origin) && !sameHost) {
    return trimmed
  }

  let { pathname } = parsed
  const wpPath = new URL(options.siteWpUrl).pathname.replace(/\/$/, '') || ''

  if (wpPath && wpPath !== '/' && pathname.startsWith(`${wpPath}/`)) {
    pathname = pathname.slice(wpPath.length) || '/'
  } else if (wpPath && wpPath !== '/' && pathname === wpPath) {
    pathname = '/'
  }

  if (!pathname.startsWith('/')) {
    pathname = `/${pathname}`
  }

  return `${pathname}${parsed.search}${parsed.hash}`
}
